<template>
  <span variant="advance" class="ml-1">
    <b-badge varient="advance"> M </b-badge>
  </span>
</template>

<script>
export default {
  name: 'MaterialityBadge',
  components: {},
  props: {},
  data() {
    return {
      show_this: false
    };
  },
  computed: {},
  created() {},
  methods: {}
};
</script>
